import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { format, subDays } from 'date-fns';

@Component({
  selector: 'app-tasks-date-range-filter',
  templateUrl: './tasks-date-range-filter.component.html',
  styleUrls: ['./tasks-date-range-filter.component.scss']
})
export class TasksDateRangeFilterComponent implements OnInit {

  @Output() public dateChanged: EventEmitter<null> = new EventEmitter();
  public tasksDateRange: UntypedFormGroup = this.fb.group({
    from: [new Date(), Validators.required],
    to: [null, Validators.required]
  });

  public constructor(private fb: UntypedFormBuilder) { }

  public ngOnInit(): void {
    this.setInitialDateRange();
  }

  public reportDateChange(): void {
    if (this.tasksDateRange.valid) {
      this.dateChanged.emit();
    }
  }

  public getFromDate(): string {
    return format(this.tasksDateRange.get('from')?.value, 'yyyy-MM-dd');
  }

  public getToDate(): string {
    return format(this.tasksDateRange.get('to')?.value, 'yyyy-MM-dd');
  }

  public setInitialDateRange(): void {
    this.tasksDateRange.get('from')?.setValue(subDays(new Date(), 7));
    this.tasksDateRange.get('to')?.setValue(new Date());
  }

  public isInitialDateSet(): boolean {
    return this.getFromDate() === format(subDays(new Date(), 7), 'yyyy-MM-dd')
      && this.getToDate() === format(new Date(), 'yyyy-MM-dd');
  }

  public setDateRange(to: Date, from: Date): void {
    this.tasksDateRange.get('from')?.setValue(new Date(from));
    this.tasksDateRange.get('to')?.setValue(new Date(to));
  }
}
